import { CredentialItem } from './credential-item'

export class ElectronicDocumentCredentialItem extends CredentialItem {

  public constructor(data: any) {
    super(data)

    const value = this.credential.eligibility_status
    switch (value) {
      case 'complete': {
        this.validityLabel = `Completed ${this.getDate(this.credential.completed_at)}`
        this.setStatusTag({ value })
        break
      }
      default: this.defaultStatusTag()
    }
  }

}
